import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { useSidebar } from '@/components/ui/sidebar'
import { VERSION as FRONTEND_VERSION } from '@/version'
import { versionService } from '@/services/version.service'

export function VersionInfo() {
  const { open, animate } = useSidebar()
  const [backendVersion, setBackendVersion] = useState<string>('...')

  useEffect(() => {
    versionService
      .getBackendVersion()
      .then(setBackendVersion)
      .catch(() => setBackendVersion('?'))
  }, [])

  return (
    <motion.div
      animate={{
        display: animate ? (open ? 'block' : 'none') : 'block',
        opacity: animate ? (open ? 1 : 0) : 1,
      }}
      className="px-2 pb-1"
    >
      <p className="text-[10px] text-muted-foreground">
        v{FRONTEND_VERSION} · v{backendVersion}
      </p>
    </motion.div>
  )
}
